import { useEffect } from "react";

export default function usePopoverDismiss({
  anchorElement,
  floatingRef,
  isOpen,
  onClose,
  shouldIgnoreTarget = null,
}) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    const handlePointerDown = (event) => {
      const target = event.target;
      const floatingElement = floatingRef?.current;

      if (typeof shouldIgnoreTarget === "function" && shouldIgnoreTarget(target, event)) {
        return;
      }

      if (floatingElement?.contains(target)) {
        return;
      }

      if (anchorElement?.contains?.(target)) {
        return;
      }

      onClose?.();
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [anchorElement, floatingRef, isOpen, onClose, shouldIgnoreTarget]);
}
